import { createContext, useContext } from "react";
import type { ReactNode } from "react";
import type { AppConfig } from "./config";

const ConfigContext = createContext<AppConfig | null>(null);

interface ConfigProviderProps {
  value: AppConfig;
  children: ReactNode;
}

/** Provides the already-loaded runtime config to the app tree. */
export function ConfigProvider({ value, children }: ConfigProviderProps) {
  return <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>;
}

/** Access the runtime config. Throws if used outside the provider. */
export function useConfig(): AppConfig {
  const config = useContext(ConfigContext);
  if (!config) {
    throw new Error("useConfig must be used within a ConfigProvider");
  }
  return config;
}
